import { render, staticRenderFns } from "./softList.vue?vue&type=template&id=ef7a5d08&scoped=true&"
import script from "./softList.vue?vue&type=script&lang=js&"
export * from "./softList.vue?vue&type=script&lang=js&"
import style0 from "./softList.vue?vue&type=style&index=0&id=ef7a5d08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7a5d08",
  null
  
)

export default component.exports